// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1b4CI","importantInfo":"styles_importantInfo__2UKOk"};